enum BuildingStatus {
  Development = 'Development',
  Construction = 'Under Construction',
  Complete = 'Complete',
  NoPlans = 'Land - No Development Plans',
  Redevelopment = 'Redevelopment',
}

export default BuildingStatus;
